import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { trpc } from '@org/clients/school';
import { ClassMultiStepForm } from '../../app/components/class/class-multi-step-form';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/classes/new')({
  component: ClassCreateRoute,
});

function ClassCreateRoute() {
  const navigate = useNavigate({ from: '/classes/new' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');

  const handleClose = () => {
    navigate({ to: '/classes', replace: true });
  };

  const handleSubmit = async () => {
    await utils.classes.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('classes.form.createTitle')}
      size="xl"
      centered
      confirmOnClose
      confirmCloseMessage={t('classes.form.confirmClose')}
      body={
        <ClassMultiStepForm
          defaultValues={{}}
          onSubmit={handleSubmit}
          onClose={handleClose}
          isEditing={false}
        />
      }
      footer={<></>}
    />
  );
}
